import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { getToken, setToken, clearToken, isTokenValid } from "@/lib/auth";
import { getMe, loginApi, registerApi } from "@/lib/api";

export default function useAuth() {
  const [user, setUser] = useState(null);
  const [loadingAuth, setLoadingAuth] = useState(true);

  useEffect(() => {
    const token = getToken();
    if (!isTokenValid(token)) {
      clearToken();
      setLoadingAuth(false);
      return;
    }
    getMe()
      .then(setUser)
      .catch(() => { clearToken(); })
      .finally(() => setLoadingAuth(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { token, user: u } = await loginApi(email, password);
    setToken(token);
    setUser(u);
    return u;
  }, []);

  const register = useCallback(async (email, password) => {
    const { token, user: u } = await registerApi(email, password);
    setToken(token);
    setUser(u);
    return u;
  }, []);

  const logout = useCallback(() => {
    clearToken();
    setUser(null);
    toast.success("Disconnesso.");
  }, []);

  return { user, loadingAuth, login, register, logout };
}
